import UIToggle from 'components/ui/UIToggle';
import React, { useEffect, useState } from "react";
import { SVGAsset } from 'res';
import "./styles.css";

/**
 * @function BaseToggleView
 * @param {STRING} mainText - This is the main text that shows the title.
 * @param {STRING} subText - This is the smaller text that shows under the title.
 * @param {STRING} className - Additional classes to add to the BaseToggleView.
 * @param {STRING} icon - This determines if the left "right chevron" will show or not. If the param is left unset, nothing will show.
 * @return {React.Component}
 * @exported true
 * @description This is the BaseToggleView. It is used as the template for all of the ToggleView variations.
 * @example
 * <BaseToggleView className={"added-class"} icon={true} mainText={"Heading goes here"} subText={"Smaller sub-text goes here."} />
 */
export default function BaseToggleView(props) {
  const mainText = props.mainText ?? "[Main Text]";
  const subText = props.subText ?? "[subText]";
  const icon = props.icon !== undefined ? (
    <div className="set-width left-icon-container">
      {props.icon}
    </div>
    ) : (<></>);
    const dataPoint = props.dataPoint ? {"data-point":props.dataPoint}:{};
    const toggleDataPoint = props.dataPoint ? props.dataPoint+"_Toggle":"";
  const className = props.className ?? "";
  const toggleBlock = props.toggleBlock ?? <></>; 
  const [ state, setState ] = useState(props.checked??false);
  const toggle = value => {
    if(props.onChange instanceof Function) {
      props.onChange(value);
    }
    setState(value)
  };

  useEffect(() => setState(props.checked ?? false), [ props.checked ]);

  return (
 <>   <div className={className + " base-toggle-view"}>
      <div className="flex-container">
        {icon}
        <div className="flex-container flex-vertical flex-width main-text">
          <div className="main-text"> <span {...dataPoint}>{mainText}</span></div>
          <div className="sub-text">{subText }</div>
        </div>
        <div className="set-width align-center-item right-toggle">
          <UIToggle onChange={ toggle} checked={ state } dataPoint={toggleDataPoint}  />
        </div>
      </div>
    </div>
  {
    state && toggleBlock
  }
</>
  );
}